import { useAtomCallback } from 'jotai/utils';
import { useCallback } from 'react';

const useCallbackSafeAtomValue = (atom) =>
  useAtomCallback(useCallback((get) => get(atom), []));

export default useCallbackSafeAtomValue;
